var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-nav",attrs:{"aria-label":"next"},on:{"click":function($event){return _vm.$store.dispatch('showNext', {n:_vm.loc, el:'#'+_vm.link})}}})}
var staticRenderFns = []

export { render, staticRenderFns }